/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const docsSchema = z.object({
	legal_name: z.string().nullable(),
	inn: z.string().nullable(),
	ogrn: z.string().nullable(),
	phone: z.string().nullable(),
	email: z.string().nullable(),
	legal_address: z.string().nullable(),
	actual_address: z.string().nullable(),
	offer_file: z.string().nullable(),
	personal_data_privacy_policy_file: z.string().nullable(),
	payment_security_policy: z.string().nullable(),
	payments_and_return_policy: z.string().nullable(),
});
